import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { SettingsService } from "./settings.service";
import { ObjectUtils, UserSettings } from "fakturnia-shared";

@Injectable({
  providedIn: 'root',
})
export class SchemeService implements OnDestroy {
    
    private _subscriptions: Subscription[] = []

    private _scheme:any = new BehaviorSubject<'dark' | 'light' | null>(null);
    public currentScheme = this._scheme.asObservable();

    constructor(
        private _settingsService: SettingsService
    ) 
    {
        this._subscriptions.push(
            this._settingsService.currentUserSettings.subscribe({
                next: (userSettings: UserSettings) => {
                    const scheme = ObjectUtils.getNestedValue(userSettings, "settings.general.scheme")

                    if(scheme === 'auto') {
                        this._isSystemDarkMode() ? this._scheme.next('dark') : this._scheme.next('light')
                        return
                    }

                    this._scheme.next(scheme)
                }
            })
        )
    }

    public setScheme(scheme: 'dark' | 'light') {
        this._scheme.next(scheme)
    }
    
    public getScheme(): 'dark' | 'light' {
        return this._scheme.value
    }

    private _isSystemDarkMode(): boolean {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    ngOnDestroy(): void {
       this._subscriptions.forEach(sub=>sub.unsubscribe())
    }
}